/**
 * 清除 service worker 生成以 ec-web 開頭的 Cache storage 內容
 * 此功能僅在客戶端執行
 */
export const clearWorkBoxCache = async () => {
  // 確保在客戶端環境且支援 caches API
  if (typeof window === 'undefined' || !('caches' in window)) {
    console.warn('Cache API not available')
    return
  }

  try {
    const cacheNames = await caches.keys()
    const deletePromises = cacheNames
      .filter(cacheName => cacheName.startsWith('ec-web'))
      .map(cacheName => caches.delete(cacheName))

    await Promise.all(deletePromises)
    console.log('Cache cleared successfully')
  } catch (error) {
    console.error('Error clearing cache:', error)
  }
}
